export const joinUsDataObj = {
  redBgPoint: require("../../images/square.png"),
};
